import { useActivationConfig } from './useActivationConfig';

export const useActivateHandler = (sendMessageToParent) => {
  const { config, params } = useActivationConfig();
  
  const handleActivateClick = () => {
    if(config.variant === 'high-value-csm'){
      return sendMessageToParent('SCHEDULE_MEETING', {
        feature: 'ai',
        redirect: config.url,
        source: 'ai_landing_page'
      })
    }
    else {
      return sendMessageToParent('ACTIVATE_FEATURE', {
        feature: 'ai',
        redirect: config.url,
        source: 'ai_landing_page'
      });
    }
    
  };

  return { handleActivateClick, config, params };
};
